import logoImage from '../assets/images/logooo.png';

export const BRAND_NAME = 'نهج الأزهر';
export const BRAND_FULL_NAME = 'منصة نهج الأزهر';
export const BRAND_TAGLINE = 'منصة الطالب الأزهري';
export const BRAND_TEACHER_NAME = 'سعيد الفقي';
export const BRAND_TEACHER_PLATFORM = 'منصة الأستاذ سعيد الفقي';

/** Names used in SEO / schema.org alternateName */
export const BRAND_ALTERNATE_NAMES = [
  BRAND_NAME,
  BRAND_FULL_NAME,
  BRAND_TEACHER_NAME,
  BRAND_TEACHER_PLATFORM,
  'الأزهر',
  'الأزهر الشريف',
  'الثانوية الأزهرية',
  'منصة الطالب الأزهري',
  'Nahj Al-Azhar',
  'Nahj Al-Azhar Platform',
  'Saeed El Feky',
] as const;

/** Front-1 style: Brand - Tagline (exact phrases Google should match) */
export const BRAND_TITLE = `${BRAND_FULL_NAME} - ${BRAND_NAME} | ${BRAND_TEACHER_NAME}`;

/** ~150 chars — ideal meta description length for SERP snippets */
export const BRAND_DESCRIPTION =
  'منصة نهج الأزهر مع الأستاذ سعيد الفقي: كورسات أونلاين لطلاب الثانوية الأزهرية في اللغة العربية والعلم الشرعي. سجّل وابدأ التعلم الآن.';

/** Clamp SEO title toward ~50–60 characters without cutting mid-word harshly */
export const clampSeoTitle = (title: string, max = 60): string => {
  const t = title.trim();
  if (t.length <= max) return t;
  return `${t.slice(0, Math.max(0, max - 1)).trimEnd()}…`;
};

/** Clamp meta description toward ~140–160 characters */
export const clampSeoDescription = (description: string, max = 158): string => {
  const d = description.trim();
  if (d.length <= max) return d;
  return `${d.slice(0, Math.max(0, max - 1)).trimEnd()}…`;
};

/** Core searchable phrases for Google */
export const BRAND_KEYWORDS = [
  'نهج الأزهر',
  'منصة نهج الأزهر',
  'سعيد الفقي',
  'الأستاذ سعيد الفقي',
  'منصة الأستاذ سعيد الفقي',
  'الأزهر',
  'الأزهر الشريف',
  'الثانوية الأزهرية',
  'طالب أزهري',
  'مناهج أزهرية',
  'اللغة العربية للأزهر',
  'النحو والصرف',
  'الفقه',
  'الحديث',
  'التفسير',
  'العقيدة',
  'تعليم أونلاين',
  'كورسات أزهرية',
  'دروس أزهرية',
  'منصة تعليمية',
  'الصف الأول الثانوي الأزهري',
  'الصف الثاني الثانوي الأزهري',
  'الصف الثالث الثانوي الأزهري',
].join(', ');

export const BRAND_THEME_COLOR = '#275e4e';
export const BRAND_ACCENT_COLOR = '#89724b';

export const SITE_URL = 'https://nahgelazhar.com';
export const CONTACT_WHATSAPP = '201023483013';
export const CONTACT_WHATSAPP_URL = `https://wa.me/${CONTACT_WHATSAPP}`;
/** Technical support — Telegram (same Egyptian number) */
export const CONTACT_TELEGRAM = '201023483013';
export const CONTACT_TELEGRAM_URL = `https://t.me/+${CONTACT_TELEGRAM}`;
export const CONTACT_FACEBOOK_URL = 'https://www.facebook.com/Mrsaeedelfeky';
export const CONTACT_YOUTUBE_URL = 'https://youtube.com/@drsaeedelfiky';

export const GRADE_SEO: Record<
  string,
  { title: string; short: string; keywords: string }
> = {
  secondary1: {
    title: 'الصف الأول الثانوي الأزهري',
    short: 'أولى ثانوي أزهري',
    keywords: 'الصف الأول الثانوي, أولى ثانوي أزهر, مناهج أولى ثانوي',
  },
  secondary2: {
    title: 'الصف الثاني الثانوي الأزهري',
    short: 'تانية ثانوي أزهري',
    keywords: 'الصف الثاني الثانوي, تانية ثانوي أزهر, مناهج تانية ثانوي',
  },
  secondary3: {
    title: 'الصف الثالث الثانوي الأزهري',
    short: 'تالتة ثانوي أزهري',
    keywords: 'الصف الثالث الثانوي, تالتة ثانوي أزهر, مراجعات ثانوية عامة أزهر',
  },
};

export { logoImage };
